export default "__VITE_ASSET__deb3db1d__"